export default (unsafeArray: any) => (Array.isArray(unsafeArray) ? unsafeArray : []);
